import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
*{

}
  body {
    padding-right: 0px !important; 
    overflow: auto !important;
    margin: 0 !important;
    font-family: Inter;
    line-height: 150%;
  .tooltip-padding {
    padding: 8px 14px 8px 12px;
  }
  .desc-tooltip-tile {
    border-radius: 4px;
    background-color: black;
    color: white;
    padding: 8px 14px 8px 12px;
    font-size: 15px;
    &.no-padding {
      padding: 0px;
    }
  }

  .desc-tooltip-arrow {
    font-size: 18;
    color:  #0b121f;
      &::before {
        background-color:  #0b121f;
      }
    }

    .ant-picker-dropdown {
    z-index: 1056111111111111111;
  }
  }`;

export default GlobalStyle;
